import { ResponsiveRouteGuard } from './responsive-route-guard';
import { RoomsModule } from './rooms/rooms.module';
import { BrowserModule } from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { from } from 'rxjs';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { HomeComponent } from './home/home.component';
import { RoomsComponent } from './rooms/rooms.component';
import { LocationComponent } from './location/location.component';
import { ContactComponent } from './contact/contact.component';
import { AirbnbButtonComponent } from './shared/components/airbnb-button/airbnb-button.component';
import { RoomDetailComponent } from './room-detail/room-detail.component';
import { RoomDetailModule } from './room-detail/room-detail.module';
import { LandingComponent } from './landing/landing.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { MobileContainerComponent } from './mobile-container/mobile-container.component';
import { AlertComponent } from './shared/toastService/alert.component';
import { AlertService } from './shared/toastService/alert.service';
import { NguCarouselModule } from '@ngu/carousel';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    RoomsComponent,
    LocationComponent,
    ContactComponent,
    AirbnbButtonComponent,
    RoomDetailComponent,
    LandingComponent,
    MobileContainerComponent,
    AlertComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    RoomsModule,
    RoomDetailModule,
    HttpClientModule,
    NgbModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    NguCarouselModule
  ],
  providers: [
    ResponsiveRouteGuard,
    AlertService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}